import React from "react";
import Images from "../../resources/images/Images";
import classes from "./UtronLogo.module.css";

const UtronLogo = () => {
  return (
    <img
      className={classes.utronLogo}
      src={Images.UTRON_LOGO}
      alt="utronLogo"
    />
  );
};

export default UtronLogo;
